import { render, staticRenderFns } from "./ReportsRfqTable.vue?vue&type=template&id=e8958b96&scoped=true"
import script from "./ReportsRfqTable.vue?vue&type=script&lang=js"
export * from "./ReportsRfqTable.vue?vue&type=script&lang=js"
import style0 from "./ReportsRfqTable.vue?vue&type=style&index=0&id=e8958b96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8958b96",
  null
  
)

export default component.exports